module.exports = function() {
  return new Worker(__webpack_public_path__ + "f2d8835a80861b5ba37d.worker.js");
};